<template>
  <v-card flat class="stat">
    <div class="stat__icon">
      <v-icon size="20">{{ icon || "mdi-chart-box-outline" }}</v-icon>
    </div>
    <p class="stat__label">{{ description }}</p>
    <p class="stat__value tabular">{{ formattedTotal }}</p>
  </v-card>
</template>

<script>
export default {
  name: "InformationCard",
  props: ["icon", "total", "description"],
  computed: {
    formattedTotal() {
      const n = Number(this.total);
      if (this.total === null || this.total === undefined || isNaN(n)) {
        return this.total != null ? this.total : "0";
      }
      return n.toLocaleString();
    }
  }
};
</script>

<style scoped>
.stat {
  background: var(--card) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius) !important;
  box-shadow: var(--shadow-card) !important;
  padding: 20px;
  height: 100%;
}
.stat__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--signal-soft);
  margin-bottom: 16px;
}
.stat__icon .v-icon {
  color: var(--signal);
}
.stat__label {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--muted-foreground);
}
.stat__value {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 26px;
  font-weight: 600;
  line-height: 1.1;
  color: var(--foreground);
  font-variant-numeric: tabular-nums;
}
</style>
